import React from "react";
import "./Page.css";

function Terms() {
  return (
    <div className="page">
      <div className="section-content" style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem' }}>
        <header>
          <h1 className="title fw-bold">TERMS OF SERVICE</h1>
        </header>

        <section>
          <h2>AGREEMENT TO OUR LEGAL TERMS</h2>
          <p>
            These Terms of Service ("Terms") govern your registration and participation in the Toke For Stroke Open golf tournament event ("Event") 
            organized by TeeTimeTony and operated through this website (the "Site"). By registering for the Event, you agree to be bound by these Terms.
          </p>
          <p>
            The Event is a golf tournament taking place at Berkshire Valley Golf Course, 28 Cozy Lake Rd, Oak Ridge, NJ 07438. 
            Registration and payment for event spots are processed through this website.
          </p>
          <p>
            You can contact us regarding the Event by email at{" "}
            <a href="mailto:enterprisewebsolutions@outlook.com">
              enterprisewebsolutions@outlook.com
            </a>
            .
          </p>
          <p>
            IF YOU DO NOT AGREE WITH ALL OF THESE TERMS, THEN YOU ARE EXPRESSLY PROHIBITED FROM REGISTERING FOR THE EVENT AND YOU MUST DISCONTINUE USE IMMEDIATELY.
          </p>
          <p>
            The Services are intended for users who are at least 18 years old.
            Persons under the age of 18 are not permitted to register for the Event.
          </p>
        </section>

        <section>
          <h2>EVENT REGISTRATION</h2>
          <p>
            <strong>Registration Process:</strong> To participate in the Event, you must complete the online registration form and pay the required registration fee. 
            Registration is subject to availability and event capacity limits.
          </p>
          <p>
            <strong>Registration Fees:</strong> The registration fee is $180 per person ($720 for a foursome). All fees are non-refundable except as specified in our Refund Policy.
          </p>
          <p>
            <strong>Event Format:</strong> The Event is an 18-hole, 4-person scramble golf tournament. All participants must follow golf course rules and regulations.
          </p>
          <p>
            <strong>Event Date and Location:</strong> The Event is scheduled for Monday, April 20, 2026 at Berkshire Valley Golf Course, 
            28 Cozy Lake Rd, Oak Ridge, NJ 07438. Event organizers reserve the right to modify the date, time, or location due to weather, 
            course conditions, or other circumstances beyond our control.
          </p>
        </section>

        <section>
          <h2>PURCHASES AND PAYMENT</h2>
          <p>We accept the following forms of payment for event registration:</p>
          <ul>
            <li>Visa</li>
            <li>Mastercard</li>
            <li>Discover</li>
            <li>American Express</li>
          </ul>
          <p>
            You agree to provide current, complete, and accurate registration and payment information. You further agree to promptly update 
            account and payment information, including email address, payment method, and payment card expiration date, so that we can complete 
            your registration and contact you as needed regarding the Event.
          </p>
          <p>
            All registration fees are in US dollars. Payment must be completed at the time of registration to secure your spot in the Event.
          </p>
          <p>
            Once payment is processed and your registration is confirmed, you will receive a confirmation email with event details and instructions.
          </p>
        </section>

        <section>
          <h2>PARTICIPANT RESPONSIBILITIES</h2>
          <p>
            <strong>Golf Course Rules:</strong> All participants must comply with Berkshire Valley Golf Course rules and regulations. 
            Failure to follow course rules may result in removal from the Event without refund.
          </p>
          <p>
            <strong>Conduct:</strong> Participants are expected to conduct themselves in a respectful and sportsmanlike manner. 
            Any behavior deemed inappropriate by event organizers may result in removal from the Event without refund.
          </p>
          <p>
            <strong>Liability:</strong> Participants acknowledge that golf involves inherent risks. By registering, you agree to participate at your own risk 
            and release the event organizers, Berkshire Valley Golf Course, and all sponsors from any liability for injuries or damages that may occur during the Event.
          </p>
          <p>
            <strong>Weather and Cancellation:</strong> The Event will proceed rain or shine unless conditions are deemed unsafe by the golf course or event organizers. 
            In the event of cancellation due to severe weather or other circumstances beyond our control, refund policies will apply as outlined in our Refund Policy.
          </p>
        </section>

        <section>
          <h2>REGISTRATION CHANGES AND CANCELLATIONS</h2>
          <p>
            Registration spots are transferable to another person with prior written notice to event organizers. 
            Changes to registration must be requested at least 7 days before the Event date.
          </p>
          <p>
            Cancellation requests must be submitted in writing. Refund eligibility is determined by our Refund Policy.
          </p>
        </section>

        <section>
          <h2>INTELLECTUAL PROPERTY</h2>
          <p>
            All content on this website, including logos, images, and text, is the property of the event organizers or their licensors. 
            You may not use, reproduce, or distribute any content from this website without prior written permission.
          </p>
        </section>

        <section>
          <h2>MODIFICATIONS TO TERMS</h2>
          <p>
            We reserve the right to modify these Terms at any time. Material changes will be communicated via email to registered participants. 
            Continued participation in the Event after such modifications constitutes acceptance of the updated Terms.
          </p>
        </section>

        <section>
          <h2>CONTACT US</h2>
          <p>
            If you have questions about these Terms or the Event, please contact us at:
          </p>
          <p>
            <a href="mailto:enterprisewebsolutions@outlook.com">
              enterprisewebsolutions@outlook.com
            </a>
          </p>
        </section>

        <p>Last updated: January 2025</p>
      </div>
    </div>
  );
}

export default Terms;
